import { PIcon } from '@porsche-design-system/components-react';
import { useCallback } from 'react';
import styled from 'styled-components';
import RangePicker, { type RangePickerFieldProps } from '../../../components/fields/RangePickerField';
import CalendarIcon from '../../../icons/mobility/calendar.svg';
import breakpoints from '../../../utilities/breakpoints';
import { RangePickerContainer } from './shared';

const RangePickerWrapperContainer = styled.div`
    @media screen and (max-width: ${breakpoints.md}) {
        & .ant-picker-panels > *:first-child button.ant-picker-header-next-btn {
            visibility: visible !important;
        }

        & .ant-picker-panels > *:first-child button.ant-picker-header-super-next-btn {
            visibility: visible !important;
        }

        .ant-picker-panels > .ant-picker-panel:nth-child(2) {
            display: none;
        }

        & .ant-picker-panel-container,
        & .ant-picker-footer {
            width: 280px;
        }

        & .ant-picker-footer-extra > div {
            flex-wrap: wrap;
        }
    }
`;
const RangePickerField = ({ disabled, ...props }: RangePickerFieldProps) => {
    const panelRender = useCallback(
        panelNode => <RangePickerWrapperContainer>{panelNode}</RangePickerWrapperContainer>,
        []
    );

    return (
        <RangePickerContainer disabled={Array.isArray(disabled) ? disabled.some(Boolean) : disabled}>
            <RangePicker
                {...props}
                disabled={disabled}
                errorIcon={
                    <PIcon aria={{ 'aria-label': 'Exclamation icon' }} color="notification-error" name="exclamation" />
                }
                panelRender={panelRender}
                suffixIcon={<CalendarIcon />}
            />
        </RangePickerContainer>
    );
};

export default RangePickerField;
